import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const selector = '.js-block-video-accordion';
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const { VideoAccordion } = await import('./video-accordion');

	[...elements].forEach((element) => {
		const videoAccordion = new VideoAccordion({
			element,
			blockClass: 'block-video-accordion',
			nextElementSelector: `${selector}-next`,
			prevElementSelector: `${selector}-prev`,
		});

		videoAccordion.init();
	});
});
